import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useIsFed } from './utils-fed';

export function compareStrings(a: string, b: string): number {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
}

export function useMEMTranslation() {
  const { t: i18nt, i18n } = useTranslation();
  const isFedVal = useIsFed();

  const t = useCallback(
    (key: string, interpolation: { [key: string]: string } = {}): string => {
      if (isFedVal && i18n.exists && i18n.exists(`${key}_Fed`)) {
        return i18nt(`${key}_Fed`, interpolation);
      }

      return i18nt(key, interpolation);
    },
    [i18nt, i18n, isFedVal]
  );

  return { t };
}

export function insertStringAtIndex(arr: string[], str: string, index: number): string[] {
  const newArr = [...arr];
  // Ensure the array is long enough
  while (newArr.length <= index) {
    newArr.push('');
  }
  // Insert the string at the specified index
  newArr[index] = str;
  return newArr;
}
